<div class="header-bar-logo" (click)="goToHomeUrl()"><vn-image [src]="logoImage" [imageClass]="logoClass" /></div>
